import { CHANGE_MODAL_STATE, ModalActionTypes, ModalState } from "./types";

const defaultState: ModalState = {
  isOpen: false
};

export default function modal(state = defaultState, action: ModalActionTypes): ModalState {
  switch (action.type) {
    case CHANGE_MODAL_STATE:
      return {
        isOpen: action.isOpen
      };
    default:
      return state;
  }
}